import { useState } from "react";
import { Stack, Box, Button } from "@mui/material";
import useDebtSalesOverdueTab from "../../hooks/useDebtSalesOverdueTab";
import TableComp from "src/components/shared/table/TableComp";
import DebtSalesFilter from "../../components/DebtSalesFilter";
import { DebtSalesPaymentDialog, DebtSalesHistoryDetailDialog } from "../Dialogs";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import { USER_TYPE } from "src/constant";
import { enqueueSnackbar } from "notistack";

const DebtSalesOverdueTab = ({ date }) => {
  const [paramsQuery, setParamsQuery] = useState({});
  const [isMultiplePayment, setIsMultiplePayment] = useState(false);

  const { bodyList, sortData, header, pagi, setPagi, total, checkedList, selectedRow, setSelectedRow, selectDetailRow, setSelectDetailRow } = useDebtSalesOverdueTab({
    date,
    paramsQuery,
  });

  const handleClosePayment = () => {
    setSelectedRow(null);
    setIsMultiplePayment(false);
  };

  const handleMultiplePayment = () => {
    if (checkedList.length) {
      const distinctCustomer = new Set(checkedList.map((item) => item?.customer?._id));
      if (distinctCustomer.size > 1) {
        enqueueSnackbar("Không thể thanh toán hàng loạt công nợ với khách hàng khác nhau", { variant: "error" });
        return;
      }
    }
    setSelectedRow(null);
    setIsMultiplePayment(true);
  };

  const handleSearchKeyword = (value) => {
    setParamsQuery((prev) => ({ ...prev, searchValue: value ?? undefined }));
  };

  const handleSetSaleSearch = (value) => {
    setParamsQuery((prev) => ({ ...prev, sales: value ?? undefined }));
  };

  const handleSetCustomerSearch = (value) => {
    setParamsQuery((prev) => ({ ...prev, customer: value ?? undefined }));
  };

  const handleSetSearchBy = (value) => {
    setParamsQuery((prev) => ({ ...prev, searchField: value ?? undefined, searchValue: undefined }));
  };

  const handleCloseDetail = () => {
    setSelectDetailRow(null);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my="14px"
      >
        <Box
          display="flex"
          gap={2}
          alignItems="center"
        >
          <SearchFilterComp
            width="fit-content"
            selectList={[
              { id: USER_TYPE.Sales, title: "Nhân viên kinh doanh", value: USER_TYPE.Sales },
              { id: USER_TYPE.Customer, title: "Khách hàng", value: USER_TYPE.Customer },
              { id: "contextCode", title: "Mã đơn hàng", value: "contextCode" },
              { id: "code", title: "Mã phiếu xuất", value: "code" },
            ]}
            getSearchKeyword={handleSearchKeyword}
            getSelectKeyword={handleSetSearchBy}
            autoComplete={{
              [USER_TYPE.Sales]: {
                endpoint: "/api/v1/users",
                type: USER_TYPE.Sales,
                state: handleSetSaleSearch,
                label: "Nhân viên kinh doanh",
                sx: { width: "250px", borderRadius: "6px" },
              },
              [USER_TYPE.Customer]: {
                endpoint: "/api/v1/customers",
                state: handleSetCustomerSearch,
                searchField: "fullName",
                label: "Khách hàng",
                sx: { width: "250px", borderRadius: "6px" },
              },
              [USER_TYPE.contextCode]: {
                searchField: "contextCode",
                label: "Mã đơn hàng",
                sx: { width: "250px", borderRadius: "6px" },
              },
              [USER_TYPE.Code]: {
                searchField: "code",
                label: "Mã phiếu xuất",
                sx: { width: "250px", borderRadius: "6px" },
              },
            }}
          />
        </Box>
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleMultiplePayment}
          >
            Thanh toán hàng loạt
          </Button>
          <DebtSalesFilter
            variant="overdue"
            setParamsQuery={setParamsQuery}
            paramsQuery={paramsQuery}
          />
        </Stack>
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        total={total}
        pagi={pagi}
        noBackground
      />
      <DebtSalesPaymentDialog
        open={!!selectedRow || isMultiplePayment}
        onClose={handleClosePayment}
        selectedRow={selectedRow}
        checkedList={checkedList}
        isMultiplePayment={isMultiplePayment}
        title={!selectedRow ? "Thanh toán hàng loạt công nợ" : `Thanh toán công nợ ${selectedRow?.code}`}
      />
    </>
  );
};

export default DebtSalesOverdueTab;
